import { LogDataModel } from '../models';

export interface ErrorLogFormatterProps {
  action: string;
  data: LogDataModel | {} | any | null;
}
export default function ErrorLogFormatter({
  action,
  data,
}: ErrorLogFormatterProps) {
  let message = action;
  let hideData = false;
  const accountRole = data?.accountRole || data?.request?.accountRole;
  if (action === 'Accounts.SaveLogo') {
    message = `Company logo update failed`;
  }
  if (action === 'Accounts.RemoveLogo') {
    message = `Company logo remove failed`;
  }
  if (action === 'Accounts.SaveWelcome') {
    message = `Welcome section update failed`;
  }
  if (action === 'Accounts.UpdateAdmin') {
    hideData = true;
    message = `${accountRole} edit failed for ${data?.email}`;
  }
  if (action === 'Accounts.RemoveAdmin') {
    message = `Admin remove failed: ${data?.personId}`;
  }
  if (action === 'Deals.AddGroup') {
    message = `Product Group add failed`;
  }
  if (action === 'Deals.UpdateGroupName') {
    message = `Product Group edit failed`;
  }
  if (action === 'DealUsers.AddUsers') {
    hideData = true;
    message = `${
      data?.email ? `${data?.email} invitation` : 'Invitation'
    }  failed`;
  }
  if (action === 'DealUsers.RemoveAccountUser') {
    message = `User remove failed: ${data?.accountUserId}`;
  }
  if (action === 'Invites.AddInvite') {
    hideData = true;
    message = `${accountRole} invitation failed for ${data?.email}`;
  }
  if (action === 'Invites.UpdateInvite') {
    hideData = true;
    message = `${accountRole} invitation update failed ${data?.email}`;
  }
  if (action === 'DealUsers.AddToDomainBlacklist') {
    hideData = true;
    message = `Failed to add ${data?.email} to domain (${data?.domainId}) blacklist`;
  }
  return <span data-exclude-lg={hideData ? true : undefined}>{message}</span>;
}
